// ScrollDirective.js
export default {
  inserted: function (el, binding) {
    const callback = binding.value
    el.addEventListener('wheel', callback)
  },
  unbind: function (el, binding) {
    const callback = binding.value
    el.removeEventListener('wheel', callback)
  }
}



// WEBPACK FOOTER //
// ./src/customJs/ScrollDirective.js